interface UpArrowProps {
  width?: number;
  height?: number;
}

export const UpArrow = ({ width = 7, height = 8 }: UpArrowProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 7 8" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M3.43098 7.54443C3.68762 7.54443 3.89566 7.33639 3.89566 7.07975V1.69607L5.89048 3.69089C6.07195 3.87236 6.36617 3.87236 6.54764 3.69089C6.72911 3.50942 6.72911 3.2152 6.54764 3.03374L3.75956 0.245656C3.57809 0.0641865 3.28387 0.0641865 3.1024 0.245656L0.314324 3.03374C0.132855 3.2152 0.132855 3.50942 0.314324 3.69089C0.495793 3.87236 0.790012 3.87236 0.971481 3.69089L2.9663 1.69607V7.07975C2.9663 7.33639 3.17435 7.54443 3.43098 7.54443Z" fill="var(--color-catch-error-red)"/>
</svg>

);